export default __webpack_public_path__ + "static/media/discovery.e93705bc.png";